import { render, staticRenderFns } from "./CookieToast.vue?vue&type=template&id=070514e1"
import script from "./CookieToast?vue&type=script&lang=ts&external"
export * from "./CookieToast?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports